import PageHero from "../components/site/PageHero";
import { useEffect } from "react";
import { trackVisit } from "../lib/api";

export default function Cookie() {
  useEffect(() => trackVisit("cookie"), []);
  return (
    <div data-testid="cookie-page">
      <PageHero eyebrow="Legale" title="Cookie" titleAccent="Policy." />
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6 prose prose-invert text-[var(--text-secondary)] space-y-5">
          <p>Il sito di Affari Oro Modena utilizza cookie tecnici e di analisi per garantire la corretta navigazione e analizzare l'utilizzo del sito.</p>
          <h2 className="font-serif text-2xl text-white">Cookie tecnici</h2>
          <p>Sono cookie strettamente necessari per il funzionamento del sito e non richiedono il consenso dell'utente.</p>
          <h2 className="font-serif text-2xl text-white">Cookie analitici</h2>
          <p>Utilizziamo cookie analitici anonimizzati per misurare l'uso del sito ed elaborare statistiche aggregate. Questi cookie non identificano il singolo utente.</p>
          <h2 className="font-serif text-2xl text-white">Gestione cookie</h2>
          <p>È possibile gestire i cookie direttamente dalle impostazioni del browser. La disabilitazione di alcuni cookie potrebbe limitare la fruibilità del sito.</p>
          <h2 className="font-serif text-2xl text-white">Cookie di terze parti</h2>
          <p>Il sito può contenere mappe Google embedded che impostano propri cookie. Per maggiori informazioni consultare la policy di Google.</p>
        </div>
      </section>
    </div>
  );
}
